export default "__VITE_ASSET__7f18d77b__"